import produce from 'immer';

import type { Action } from 'Lib/reduxType';

import {
  getCommonResetAction,
  STATE_ERROR,
  STATE_INITIAL,
  STATE_LOADING,
  STATE_SUCCESS,
} from 'Store/commonActions';
import { LOGIN_START, LOGIN_SUCCESS } from 'Store/mfa/constants';

import {
  POST_PHONE_NUMBER_ERROR,
  POST_PHONE_NUMBER_SUCCESS,
  RESET_POST_PHONE_NUMBER_STATE,
  RESET_VALIDATE_SMS_CODE_STATE,
  SET_OTP_SENDING,
  SET_PHONE_NUMBER,
  SET_PHONE_NUMBER_SENDING,
  SET_SMS_AUTH_STATE,
  SET_SMS_CAPTCHA_REFERENCE_TOKEN,
  SUBMIT_SMS_CAPTCHA_ERROR,
  SUBMIT_SMS_CAPTCHA_SUCCESS,
  VALIDATE_SMS_CODE_ERROR,
  VALIDATE_SMS_CODE_SUCCESS,
} from './constants';
import initialState from './initialState';
import type { SMSState } from './types';

export const reducer = produce<SMSState, [Action]>((draft, action) => {
  switch (action.type) {
    case SET_PHONE_NUMBER_SENDING:
      draft.postPhoneNumberState = STATE_LOADING;
      break;
    case SET_PHONE_NUMBER:
      draft.phoneNumber = action.payload.phoneNumber;
      break;
    case POST_PHONE_NUMBER_SUCCESS:
      draft.otpLength = action.payload.otpLength;
      draft.smsSent = action.payload.smsSent;
      draft.postPhoneNumberState = STATE_SUCCESS;
      break;
    case POST_PHONE_NUMBER_ERROR:
      draft.postPhoneNumberError = action.payload.error;
      draft.postPhoneNumberState = STATE_ERROR;
      break;
    case SUBMIT_SMS_CAPTCHA_SUCCESS:
      draft.submitSMSCaptchaError = null;
      break;
    case SUBMIT_SMS_CAPTCHA_ERROR:
      draft.submitSMSCaptchaError = action.payload.error;
      break;
    case SET_OTP_SENDING:
      draft.validateSmsCodeState = STATE_LOADING;
      break;
    case VALIDATE_SMS_CODE_SUCCESS:
      draft.validateSmsCodeState = STATE_SUCCESS;
      break;
    case VALIDATE_SMS_CODE_ERROR:
      draft.validateSmsCodeError = action.payload.error;
      draft.validateSmsCodeState = STATE_ERROR;
      break;
    case RESET_POST_PHONE_NUMBER_STATE:
      if (action.payload.clearPhoneNumber) {
        draft.phoneNumber = '';
      }
      draft.postPhoneNumberState = STATE_INITIAL;
      draft.postPhoneNumberError = null;
      break;
    case RESET_VALIDATE_SMS_CODE_STATE:
      draft.validateSmsCodeState = STATE_INITIAL;
      draft.validateSmsCodeError = null;
      draft.smsSent = false;
      break;
    case SET_SMS_AUTH_STATE:
      draft.smsAuthState = action.payload.smsAuthState;
      break;
    case SET_SMS_CAPTCHA_REFERENCE_TOKEN:
      draft.smsCaptchaReferenceToken = action.payload.smsCaptchaReferenceToken;
      break;
    case LOGIN_START:
    case LOGIN_SUCCESS:
    case getCommonResetAction(action.type):
      return initialState;
    default:
      break;
  }
}, initialState);
